interface Comparer<T> {
	(a: T, b: T): boolean;
}

export const isSubArray = <T>(root: Array<T>, sub: Array<T>, comparer: Comparer<T> = (a, b) => a === b): boolean => {
	if (sub.length > root.length) return false;
	return sub.every((s) => root.some((r) => comparer(r, s)));
};
